import {
  FunctionComponent,
  ReactNode,
  useContext,
  useState,
  useEffect,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Flex,
  Box,
  Grid,
  GridItem,
  Text,
  Stack,
  Avatar,
  Menu,
  MenuList,
  MenuButton,
  MenuItem,
  Badge,
  // Skeleton,
  Button,
  CircularProgress,
  Spinner,
  Tab,
  Tabs,
  TabPanel,
  TabPanels,
  TabList,
  Divider,
  useToast,
  // Drawer,
  // DrawerBody,
  // DrawerFooter,
  // DrawerHeader,
  // DrawerOverlay,
  // DrawerContent,
  // DrawerCloseButton,
} from "@chakra-ui/react";
import {
  MdNotificationsNone,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdLogout,
  MdSettings,
  MdLens,
} from "react-icons/md";
import { useQueryClient } from "@tanstack/react-query";
import { Player } from "@lottiefiles/react-lottie-player";
import { format } from "date-fns";
import Select from "react-select";

import { Navigation_Lg, Navigation_Sm } from "src/components";

import Loader from "src/assets/images/splash_screen_loader.json";
import InfoIcon from "src/assets/images/info.png";
import MonitorIcon from "src/assets/images/monitor_info.png";

import { Wrapper } from "src/Layout/style";

import { GetUserProfileContext } from "src/Context/UserProfile";
import useLocalStorage from "src/hooks/useLocalstorage";

import { textTruncate } from "src/helpers/truncateText";
import { APP_PATHS, BASE_PATHS } from "src/Constant/path";
import { CancelSubscriptionContext } from "src/Context/Billing/CancelReactivateSubscription";
import { MonitorOngoingBulkCheckContext } from "src/Context/RadarCheck/MonitorOngoingBulkCheck";
// import { OngoingBulkTransactionsContext } from "src/Context/TransactionMonitoring/OngoingBulkTransactions";

import WarningIcon from "src/assets/images/warning.png";
import { NotificationAlertContext } from "src/Context/UserProfile/NotificationAlert";

type Props = {
  children: ReactNode;
};

type NavbarIconProps = {
  "radar-spotlight": string;
  "aml-spotlight": string;
  dashboard: string;
  "check-history": string;
  "radar-check": string;
  "aml-check": string;
  "radar-rules": string;
  "aml-rules": string;
  report: string;
  wallet: string;
  settings: string;
  configuration: string;
  documentation: string;
  "radar-analytics": string;
  "aml-analytics": string;
  "back-office": string;
  "transaction-monitoring": string;
};

type NavbarIcons = {
  [key in keyof NavbarIconProps]: string;
};

const Layout: FunctionComponent<Props> = ({ children }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const toast = useToast();
  const { data, isFetching, error } = useContext(GetUserProfileContext);
  const { data: monitorBulkdata, isFetching: monitorBulkIsFetching } =
    useContext(MonitorOngoingBulkCheckContext);
  const { isPending } = useContext(CancelSubscriptionContext);

  const {
    data: Notification_Alert_Data,
    isFetching: isFetching_Notification_Alert,
    mutateAsync,
    // notificationReadData,
    isPending: isPendingReadNotification,
  } = useContext(NotificationAlertContext);
  const [storedData] = useLocalStorage("cld", {});
  const [storedOrg] = useLocalStorage("clo", {});
  const [storedAccess, setStoredAccess] = useLocalStorage("clu", {});

  const tenant = JSON.parse(localStorage.getItem("clu"));

  const { pathname } = useLocation();
  const current_path = pathname?.split("/")[2] as keyof NavbarIcons;

  const [isToggled, setIsToggled] = useState(false);
  const [switchOrg, setSwitchorg] = useState(false);
  const [isOpen, setIsOpen] = useState<any>(false);
  const [currentIndex, setCurrentIndex] = useState<number>();
  const [isCollapse, setIsCollapse] = useState(false);
  const [username, setUsername] = useState("");
  const [isShowNotification, setIsShowNotification] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [isSelectedOrgError, setIsSelectedOrgError] = useState(true);

  useEffect(() => {
    if (isFetching && switchOrg) {
      setSwitchorg(false);
    }
  }, [switchOrg]);

  useEffect(() => {
    if (error && error?.response?.status === 403) {
      setIsSelectedOrgError(true);
    }
  }, [switchOrg, error]);

  useEffect(() => {
    const use =
      Object.entries(storedData).length > 0
        ? `${storedData.firstname} ${storedData.lastname}`
        : data
          ? `${data.user.first_name} ${data.user.last_name}`
          : "Hi Welcome";
    setUsername(use);
  }, [storedData, data]);

  const handleToggle = () => {
    setIsToggled(!isToggled);
  };

  const handleLogout = () => {
    console.log(tenant);
    const isWithRadar = localStorage.getItem("login-with");
    let path = "";
    if (isWithRadar === "radar") {
      localStorage.clear();
      path = `${window?.location?.origin}/login`;
    } else {
      localStorage.clear();
      path =
        tenant.host === `https://radardemo.prembly.com`
          ? `https://radardemo.prembly.com/login`
          : // : tenant
            `${window?.location?.origin}/login`;
    }

    window.location.replace(path);
  };

  const handleSelectOrganisation = (organisation: any) => {
    setStoredAccess({
      ...storedAccess,
      org: organisation.id,
      businessName: organisation.name,
    });
    setSwitchorg(true);
    setIsSelectedOrgError(false);
    queryClient.invalidateQueries();
    navigate(`${BASE_PATHS.APP}/${APP_PATHS.SPOTLIGHT}`);
  };

  const imgUrl =
    Object.entries(storedData).length > 0
      ? storedData.p_p
      : data
        ? data.user.image
        : "";

  const organisations =
    Object.entries(storedOrg).length > 0
      ? storedOrg.organisations.map(({ organisation }: any) => (
          <MenuItem
            onClick={() => handleSelectOrganisation(organisation)}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
            pointerEvents={
              data && data.organisation.prembly_organisation === organisation.id
                ? "none"
                : "unset"
            }
            // isDisabled={
            //   data && data.organisation.prembly_organisation === organisation.id
            // }
          >
            <Text ml={2} fontSize={"13px"}>
              {textTruncate(organisation.name, 30)}
            </Text>
            {data &&
              data.organisation.prembly_organisation === organisation.id && (
                <Badge colorScheme={"green"}>Active</Badge>
              )}
          </MenuItem>
        ))
      : "";

  const orgSwitch =
    Object.entries(storedOrg).length > 0
      ? storedOrg.organisations.map(({ organisation }: any) => ({
          label: organisation?.name,
          value: organisation?.id,
          org: organisation,
        }))
      : [];

  const handleSelectedOrg = (val: any) => {
    setSelectedOrg(val.org);
  };

  const handleRunTour = () => {
    setStoredAccess({
      ...storedAccess,
      isStartedTourGuide: true,
    });
    setIsOpen(true);
    setCurrentIndex(0);
    navigate("/app/dashboard");
  };

  const handleCloseTour = () => {
    setStoredAccess({
      ...storedAccess,
      isStartedTourGuide: true,
    });
  };

  const handleCollapse = () => {
    setIsCollapse(!isCollapse);
  };

  const handleShowNotification = () => {
    setIsShowNotification(!isShowNotification);
  };

  const handleViewBulkRecord = () => {
    navigate(
      `${BASE_PATHS.APP}/${APP_PATHS.RADAR_CHECK}?q=individual&view_detail=processing&tab=bulk`,
    );
  };

  const handleClose = () => {
    window.location.href = `${process.env.REACT_APP_MAIN_URL}`;
  };

  const handleMarkAsRead = async (notification: any) => {
    try {
      const response = await mutateAsync(notification.id);
      if (response.status === 200) {
        queryClient.invalidateQueries({ queryKey: ["notification_alert"] });
      }
    } catch (error: any) {
      const errMsg = error
        ? error.response.data.detail
        : "An error occured, Please try again";
      toast({
        description: errMsg,
        status: "error",
        duration: 9000,
        isClosable: true,
        variant: "left-accent",
      });
    }
  };

  return (
    <>
      {!isFetching &&
        !isPending &&
        data &&
        data.organisation.days_left !== 0 && (
          <Box
            backgroundColor={"#FFF5EA"}
            padding={"1em"}
            position={"fixed"}
            zIndex={20}
            top={0}
            left={0}
            right={0}
            width={"100%"}
          >
            <Flex
              direction={"row"}
              alignItems={"center"}
              gap={2}
              justifyContent={"center"}
            >
              <img src={InfoIcon} alt="information" />
              <Text textAlign={"center"} fontWeight={500} fontSize={"14px"}>
                You have {data.organisation.days_left}{" "}
                {`${data.organisation.days_left === 0 ? "day" : "days"}`} left
                in the trial.
              </Text>
            </Flex>
          </Box>
        )}

      <Wrapper
        display={{ base: "flex" }}
        flexDirection={{ base: "column" }}
        mt={data && data.organisation.days_left !== 0 ? 12 : 0}
      >
        {!monitorBulkIsFetching &&
          monitorBulkdata &&
          monitorBulkdata?.has_ongoing_check && (
            <Box
              backgroundColor={"#DAE6F8"}
              borderBottom={"1px solid #0066F5"}
              padding={"1em"}
              position={"sticky"}
              zIndex={40}
              top={0}
              width={"100%"}
            >
              <Flex
                direction={"row"}
                alignItems={"center"}
                gap={2}
                justifyContent={"center"}
              >
                <img src={MonitorIcon} alt="information" />
                <Text
                  textAlign={"center"}
                  fontWeight={500}
                  fontSize={"14px"}
                  color={"#0B0A0A"}
                >
                  You currently have a Bulk check running on this account.{" "}
                  <Button
                    variant={"link"}
                    fontSize={"14px"}
                    padding={"0px"}
                    margin={"0px"}
                    color={"#0066F5"}
                    onClick={handleViewBulkRecord}
                  >
                    See details
                  </Button>
                </Text>
              </Flex>
            </Box>
          )}
        <Box display={{ base: "none", md: "block" }} className="nav_container">
          <Navigation_Lg
            isOpen={isOpen}
            currentIndex={currentIndex}
            handleRunTour={handleRunTour}
            handleCloseTour={handleCloseTour}
            storedAccess={storedAccess}
            handleCollapse={handleCollapse}
            isCollapse={isCollapse}
          />
        </Box>
        <Box display={{ base: "block", md: "none" }}>
          <Navigation_Sm data={null} />
        </Box>
        <Box
          as="main"
          w={{ base: "100%", md: isCollapse ? "95%" : "82%", "2xl": "70%" }}
          marginLeft={{
            base: "0px",
            md: isCollapse ? "5%" : "18%",
            "2xl": "23%",
          }}
          mt={{ base: 10, md: "0px" }}
          className="content"
          // background={"#FCFCFC"}
          // height={"100vh"}
        >
          <Box
            borderBottom={"1px solid rgba(0, 0, 0, 0.12)"}
            mb={4}
            py={5}
            position={"sticky"}
            top={
              !monitorBulkIsFetching && monitorBulkdata?.has_ongoing_check
                ? "50px"
                : 0
            }
            left={0}
            right={0}
            zIndex={4}
            bg={"#fff"}
            // w={{ base: "100%", md: "85%", "2xl": "85%" }}
            // marginLeft={{ base: "0px", md: "15%" }}
            display={{ base: "none", md: "block" }}
          >
            <Grid
              templateColumns={"repeat(2, 1fr)"}
              alignItems={"center"}
              px={5}
            >
              <GridItem>
                <Stack direction={"row"} alignItems={"center"} gap={2}>
                  {/* {current_path && current_path in Navbar_Icons ? (
                    <img
                      src={Navbar_Icons[current_path] as string}
                      style={{ width: "18px" }}
                    />
                  ) : null} */}
                  <Text
                    textTransform={"capitalize"}
                    color={"#0B0A0A"}
                    fontSize={"16px"}
                    fontWeight={700}
                  >
                    {current_path && current_path !== "configuration"
                      ? current_path.replace("-", " ")
                      : current_path === "configuration"
                        ? "API/SDK"
                        : ""}
                  </Text>
                </Stack>
              </GridItem>
              <GridItem>
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  justifyContent={"flex-end"}
                  gap={3}
                >
                  <Box
                    position={"relative"}
                    width={"60%"}
                    display={"flex"}
                    alignItems={"end"}
                    justifyContent={"end"}
                  >
                    <Box
                      id="google_translate_element"
                      zIndex={90}
                      // position={"fixed"}
                      // right={400}
                      mr={20}
                      // top={7}
                    />
                    <Box position={"relative"}>
                      <MdNotificationsNone
                        fontSize={"20px"}
                        style={{ cursor: "pointer", textAlign: "right" }}
                        onClick={handleShowNotification}
                      />
                      {Notification_Alert_Data &&
                        Notification_Alert_Data.filter(
                          (notification: any) => !notification.has_read,
                        ).length !== 0 && (
                          <Box
                            position={"absolute"}
                            background={"red"}
                            width={"10px"}
                            height={"10px"}
                            borderRadius={"50px"}
                            top={-1}
                            right={0}
                          />
                        )}
                    </Box>
                    {isShowNotification && (
                      <Box
                        position={"absolute"}
                        width={"100%"}
                        top={"33px"}
                        right={0}
                        height={"90vh"}
                        background={"white"}
                        borderRadius={"8px"}
                        boxShadow="0px 1px 4px 0px #00000024"
                        overflowY={"scroll"}
                      >
                        <Tabs>
                          <TabList
                            display={"flex"}
                            alignItems={"center"}
                            justifyContent={"space-between"}
                          >
                            <Box display={"flex"} alignItems={"center"}>
                              <Tab fontSize={"13px"}>All</Tab>
                              <Tab fontSize={"13px"}>Unread</Tab>
                            </Box>
                          </TabList>

                          <TabPanels>
                            <TabPanel>
                              {isFetching_Notification_Alert ? (
                                <Box
                                  width={"50%"}
                                  m={"auto"}
                                  textAlign={"center"}
                                >
                                  <CircularProgress
                                    color="primary"
                                    isIndeterminate
                                    size={"20px"}
                                  />
                                </Box>
                              ) : Notification_Alert_Data.length === 0 ? (
                                <Text>No notification</Text>
                              ) : (
                                Notification_Alert_Data.map(
                                  (notification: any) => (
                                    <Box mb={5}>
                                      <Stack
                                        direction={"row"}
                                        alignItems={"flex-start"}
                                        pb={3}
                                      >
                                        {!notification.has_read ? (
                                          <Box width={"5%"} mt={1}>
                                            <MdLens
                                              size={8}
                                              color={"#251169"}
                                            />
                                          </Box>
                                        ) : (
                                          <Box width={"5%"} />
                                        )}
                                        <Stack gap={1}>
                                          <Text
                                            fontSize={"12px"}
                                            fontWeight={500}
                                          >
                                            {notification.description}
                                          </Text>
                                          <Stack
                                            direction={"row"}
                                            alignItems={"center"}
                                            justifyContent={"space-between"}
                                          >
                                            <Text fontSize={"10px"}>
                                              {format(
                                                new Date(
                                                  notification.created_at,
                                                ),
                                                "MMMM do, yyyy. hh:mm a",
                                              )}
                                            </Text>
                                            {!notification.has_read && (
                                              <Text
                                                fontSize={"12px"}
                                                cursor={"pointer"}
                                                display={"flex"}
                                                alignItems={"center"}
                                                gap={2}
                                                pointerEvents={
                                                  isPendingReadNotification
                                                    ? "none"
                                                    : "unset"
                                                }
                                                onClick={() =>
                                                  handleMarkAsRead(notification)
                                                }
                                              >
                                                Mark as read{" "}
                                                {isPendingReadNotification ? (
                                                  <Spinner size={"xs"} />
                                                ) : (
                                                  ""
                                                )}
                                              </Text>
                                            )}
                                          </Stack>
                                        </Stack>
                                      </Stack>
                                      <Divider />
                                    </Box>
                                  ),
                                )
                              )}
                            </TabPanel>
                            <TabPanel>
                              {isFetching_Notification_Alert ? (
                                <Box
                                  width={"50%"}
                                  m={"auto"}
                                  textAlign={"center"}
                                >
                                  <CircularProgress
                                    color="primary"
                                    isIndeterminate
                                    size={"20px"}
                                  />
                                </Box>
                              ) : Notification_Alert_Data.length === 0 ? (
                                <Text>No notification</Text>
                              ) : Notification_Alert_Data.filter(
                                  (notification: any) => !notification.has_read,
                                ).length === 0 ? (
                                <Text
                                  fontSize={"12px"}
                                  textAlign={"center"}
                                  pt={3}
                                >
                                  You currently do not have any unread
                                  notification
                                </Text>
                              ) : (
                                Notification_Alert_Data.filter(
                                  (notification: any) => !notification.has_read,
                                ).map((notification: any) => (
                                  <Box mb={5}>
                                    <Stack
                                      direction={"row"}
                                      alignItems={"flex-start"}
                                      pb={3}
                                    >
                                      <Box width={"5%"} mt={1}>
                                        <MdLens size={8} color={"#251169"} />
                                      </Box>
                                      <Stack gap={1}>
                                        <Text
                                          fontSize={"12px"}
                                          fontWeight={500}
                                        >
                                          {notification.description}
                                        </Text>
                                        <Stack
                                          direction={"row"}
                                          alignItems={"center"}
                                          justifyContent={"space-between"}
                                        >
                                          <Text fontSize={"10px"}>
                                            {format(
                                              new Date(notification.created_at),
                                              "MMMM do, yyyy. hh:mm a",
                                            )}
                                          </Text>
                                          <Text
                                            fontSize={"12px"}
                                            cursor={"pointer"}
                                          >
                                            Mark as read
                                          </Text>
                                        </Stack>
                                      </Stack>
                                    </Stack>
                                    <Divider />
                                  </Box>
                                ))
                              )}
                            </TabPanel>
                          </TabPanels>
                        </Tabs>
                        {/* {isFetching_Tm_Data ? (
                          <Box width={"50%"} m={"auto"} textAlign={"center"}>
                            <CircularProgress
                              color="primary"
                              isIndeterminate
                              size={"20px"}
                            />
                          </Box>
                        ) : !isFetching_Tm_Data && TM_Data.length === 0 ? (
                          <Text fontSize={"12px"} textAlign={"center"}>
                            No notifications yet
                          </Text>
                        ) : (
                          TM_Data &&
                          TM_Data.map((res: any) => (
                            <Box
                              border={"1px solid #E6E6E6"}
                              borderRadius={"8px"}
                              p={2}
                              mb={4}
                            >
                              <Stack
                                direction={"row"}
                                alignItems={"flex-start"}
                              >
                                <DocumentUpload />
                                <Stack
                                  width={"100%"}
                                  direction={"column"}
                                  gap={0}
                                >
                                  <Text
                                    color={"#0B0A0A"}
                                    fontSize={"12px"}
                                    fontWeight={600}
                                    mb={0}
                                  >
                                    Uploading file
                                  </Text>
                                  <Stack
                                    direction={"column"}
                                    alignItems={"flex-start"}
                                    mt={1}
                                  >
                                    <Text fontSize={"12px"} color={"#0B0A0A"}>
                                      {res.name}
                                    </Text>
                                    <Box
                                      width={"100%"}
                                      display={"flex"}
                                      flexDirection={"column"}
                                      alignItems={"flex-start"}
                                    >
                                      <Progress
                                        width={"100%"}
                                        value={res.percentage_processed}
                                        borderRadius={"8px"}
                                      />
                                      <Text
                                        fontSize={"13px"}
                                        display={"flex"}
                                        alignItems={"flex-end"}
                                        width={"25%"}
                                        gap={4}
                                      >
                                        {res.percentage_processed}%
                                      </Text>
                                    </Box>
                                  </Stack>
                                </Stack>
                              </Stack>
                            </Box>
                          ))
                        )} */}
                      </Box>
                    )}
                  </Box>

                  {/* {!isFetching && ( */}
                  {/* // <Avatar */}
                  {/* //   textTransform={"uppercase"} */}
                  {/* //   name={`${data && data.user.first_name} ${ */}
                  {/* //     data && data.user.last_name */}
                  {/* //   }`} */}
                  {/* //   size={"sm"} */}
                  {/* //   src={imgUrl} */}
                  {/* // /> */}
                  <Avatar
                    textTransform={"uppercase"}
                    name={username}
                    size={"sm"}
                    src={imgUrl}
                  />
                  {/* )} */}
                  {/* <Box>
                    {isFetching ? (
                      <Skeleton size={"12px"}>
                        <Text
                          as={"span"}
                          fontSize={"12px"}
                          border={"1px solid red"}
                        >
                          loading
                        </Text>
                      </Skeleton>
                    ) : (
                      <>
                        <Text
                          fontSize={"12px"}
                          fontWeight={500}
                          color="primary"
                          textTransform={"capitalize"}
                        >
                          {data && textTruncate(data.organisation.name, 20)}
                        </Text>
                        <Text
                          fontSize={"12px"}
                          fontWeight={500}
                          color="primary"
                          textTransform={"capitalize"}
                        >
                          {data &&
                            textTruncate(
                              `${data.user.first_name} ${data.user.last_name}`,
                              20
                            )}
                        </Text>
                      </>
                    )}
                  </Box> */}
                  <Box className="profiles thirteenth-step">
                    <Menu closeOnBlur={false} isLazy gutter={7}>
                      <MenuButton pt={2} onClick={handleToggle}>
                        {isToggled ? (
                          <MdKeyboardArrowUp
                            fontSize={"20px"}
                            cursor={"pointer"}
                          />
                        ) : (
                          <MdKeyboardArrowDown
                            fontSize={"20px"}
                            cursor={"pointer"}
                          />
                        )}
                      </MenuButton>
                      <MenuList mt={2}>
                        <Stack alignItems={"center"} flexDirection={"column"}>
                          <Avatar
                            textTransform={"uppercase"}
                            name={username}
                            size={"lg"}
                            src={imgUrl}
                          />
                          <Text fontSize={"13px"}>{username}</Text>
                        </Stack>
                        <Box
                          mt={2}
                          py={4}
                          borderTop={"1px solid rgba(0, 0, 0, 0.12)"}
                          borderBottom={"1px solid rgba(0, 0, 0, 0.12)"}
                          height={"auto"}
                          maxHeight={"300px"}
                          overflowY={"scroll"}
                        >
                          {organisations}
                        </Box>
                        <MenuItem>
                          <MdSettings />
                          <Text ml={2} fontSize={"13px"}>
                            Settings
                          </Text>
                        </MenuItem>
                        <MenuItem onClick={handleLogout}>
                          <MdLogout />
                          <Text ml={2} fontSize={"13px"}>
                            Logout
                          </Text>
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </Box>
                </Stack>
              </GridItem>
            </Grid>
          </Box>
          <Box px={5} mt={{ base: "2em", md: "2em" }} pb={20}>
            {children}
          </Box>
        </Box>
      </Wrapper>
      {isFetching && switchOrg && (
        <Box
          bg="white"
          position={"fixed"}
          top={0}
          right={0}
          left={0}
          zIndex={999999}
          height={"100vh"}
        >
          <Box
            textAlign={"center"}
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            height={"100vh"}
            position={"fixed"}
            width={"100%"}
            margin={"0px auto"}
          >
            <Player
              src={Loader}
              style={{ width: "100px" }}
              className="player"
              loop
              autoplay
            />
            <Text mt={0}>Please wait while we setup your organisation!</Text>
          </Box>
        </Box>
      )}

      {isSelectedOrgError && error && error?.response?.status === 403 && (
        <Box
          position={"fixed"}
          zIndex={9999999}
          top={0}
          height={"100vh"}
          width={"100%"}
          background={"#767676ab"}
        >
          <Box
            width={"30%"}
            margin={"auto"}
            background={"white"}
            position={"absolute"}
            transform={"translate(-50%, -50%)"}
            top="30%"
            left="50%"
            p={4}
            borderRadius={"10px"}
            display={"flex"}
            alignItems={"center"}
            flexDirection={"column"}
          >
            <img
              src={WarningIcon}
              alt="icon"
              style={{
                width: "60px",
                height: "60px",
                textAlign: "center",
              }}
            />
            <Text fontSize={"15px"} textAlign={"center"} mt={3} mb={4}>
              {error && error.response.data.detail}
            </Text>
            {error &&
              error?.response?.data?.detail ===
                "Please ensure your organisation is activated and verified to access radar" && (
                <Box width={"100%"}>
                  <Select
                    options={orgSwitch}
                    onChange={handleSelectedOrg}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: state.isFocused
                          ? "2px solid #251169 !important"
                          : "1px solid #e2e8f0 !important",
                        boxShadow: state.isFocused
                          ? "none"
                          : provided.boxShadow,
                        borderRadius: "8px",
                        "&:hover": {
                          boxShadow: state.isFocused
                            ? "none"
                            : provided.boxShadow,
                        },
                        "&:focus": {
                          outline: "1px solid red",
                        },
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        fontSize: "14px",
                        textAlign: "left",
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        fontSize: "14px",
                        cursor: "pointer",
                        textAlign: "left",
                        background: state.isSelected ? "#251169" : "white",
                        "&:hover": {
                          background: "#e6e6e6",
                          color: "#000",
                        },
                      }),
                    }}
                  />
                  <Box mt={4} mb={3}>
                    <Button
                      size={"md"}
                      width={"full"}
                      onClick={() => handleSelectOrganisation(selectedOrg)}
                    >
                      Switch Organisation
                    </Button>
                  </Box>
                </Box>
              )}
            <Button
              size={"md"}
              width={"full"}
              onClick={handleClose}
              variant={
                error &&
                error?.response?.data?.detail !==
                  "Please ensure your organisation is activated and verified to access radar"
                  ? "primary"
                  : "ghost"
              }
            >
              Back to Prembly
            </Button>
          </Box>
        </Box>
      )}

      {isFetching && !switchOrg && (
        <Box
          height={"100vh"}
          position={"fixed"}
          width={"full"}
          top={0}
          left={0}
          background={"#ffffffe3"}
          zIndex={99999}
        >
          <Box
            height={"100vh"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            flexDirection={"column"}
          >
            <Spinner size={"lg"} color="primary" thickness="3px" />
          </Box>
        </Box>
      )}
    </>
  );
};

export default Layout;
